import { useLocation } from 'react-router-dom';

/**
 * add parameters to path
 * @param {string} route
 * @param {object} params
 * @returns path with parameters
 */
const routeWithParams = (route = '', params = {}) => {
  let output = route;

  Object.keys(params).forEach((key) => {
    output = output.replace(`:${key}?`, params[key]);
    output = output.replace(`:${key}`, params[key]);
  });
  output = output.replace(/\/:([^/]+)\?/g, '');

  return output;
};

const WithLocationKey = ({ children }) => {
  const location = useLocation();
  return children(location.key);
};

export {
  routeWithParams,
  WithLocationKey,
};
